module.exports = __webpack_public_path__ + "img/Laminechaud_Falci.8ca2754e.jpg";